import LeftArrow from 'assets/icons/LeftArrow'
import RoutePath from 'components/route_path/RoutePath'
import {
  DesHeading,
  DesHeading1,
  Outline,
  Outline1,
} from 'modules/OfferLetter/Style/style'
import { FooterFlex } from 'modules/Roles/Style/style'
import { BreadCrumns, TopNav1 } from 'modules/ViewRole/Style/style'
import React, { useEffect, useState } from 'react'
import { Link,useNavigate, useParams } from 'react-router-dom'

import { Col, Divider, Row, Form } from 'antd'
import Button from 'components/Button'
import {
  getCorporateRequestDoc,
  getStudentDocumentList,
  SingleOffer,
  uploadDocumentRequested,
} from 'modules/OfferLetter/actions'
import { useDispatch } from 'react-redux'
import UploadForm from './UploadForms'

const OfferUploadDocument = () => {
  const params = useParams()
  const dispatch = useDispatch()
  const [documentList, setDocumentList] = useState([])
  const [studentDocumentList, setStudentDocumentList] = useState([])
  const [documentLoading, setDocumentLoading] = useState(true)
  const [studentDocumentListLoading, setStudentDocumentListLoading] =
    useState(true)
  const [fullDocument, setFullDocument] = useState([])
  const [form] = Form.useForm()
  const navigate = useNavigate()

  useEffect(() => {
    ;(async () => {
      let responce = await dispatch(SingleOffer(params.offerID))
      if (responce?.status >= 200 && responce?.status <= 300) {
        let data = await dispatch(
          getCorporateRequestDoc(
            responce?.data?.data?.role?.corporate?.id,
            responce?.data?.data?.driveId,
            responce?.data?.data?.roleId
          )
        )
        setDocumentList(data?.data?.data?.result)
        setDocumentLoading(false)
      }
    })()

    return () => {}
  }, [])
  useEffect(() => {
    ;(async () => {
      let responce = await dispatch(getStudentDocumentList())
      setStudentDocumentList(responce?.data?.data?.result)
      setStudentDocumentListLoading(false)
    })()

    return () => {}
  }, [])
  useEffect(() => {
    if (!documentLoading && !studentDocumentListLoading) {
      const final = []

      const setFinalData = []

      for (const item1 of documentList) {
        let matched = false

        for (const item2 of studentDocumentList) {
          if (item1?.docId === item2?.doc_id) {
            const mergedItem = { ...item1, doc: item2.doc }
            final.push(mergedItem)
            matched = true
            break // No need to continue searching once a match is found
          }
        }

        if (!matched) {
          const mergedItem = { ...item1, doc: null }
          final.push(mergedItem)
        }
      }
      final?.map((data, index) => {
        let formName = 'documentForm_' + index
        form.setFieldsValue({
          [formName]: {
            studentId: data?.studentId,
            docId: data?.docId?.replace(/\s/g, ''),
            docName: data?.docName,
            doc: data?.doc,
            mandatory: data?.mandatory,
          },
        })
        return setFinalData.push({
          component: UploadForm,
          formName: formName,
          docName: data?.docName,
          mandatory: data?.mandatory,
        })
      })
      setFullDocument(setFinalData)
    }
  }, [documentList, studentDocumentList])


 
  const uploadDocument = value => {
    const output = []

    for (const key in value) {
      if (value.hasOwnProperty(key) && value[key]?.doc != null) {
        output.push(value[key])
      }
    }
    if (!output?.length) {
      navigate('/offerReceived')
    } else {
      let final = {
        document: output,
      }
      dispatch(uploadDocumentRequested(final, navigate))
    }
  }
  return (
    
      <Outline>
        <TopNav1>
          <BreadCrumns>
            <Link to="/offerReceived">
              <LeftArrow />
            </Link>
            &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
            <RoutePath
              from="Offer Letter"
              on="Upload Document"
              path="/offerReceived"
            />
          </BreadCrumns>
        </TopNav1>
        <Outline1>
          <DesHeading>Documents Upload</DesHeading>
          <br></br>
          <br></br>
          <br></br>
          <Form
            style={{ width: '100%' }}
            scrollToFirstError
            onFinish={uploadDocument}
            id={'documentForm'}
            layout="vertical"
            form={form}
          >
            {!!fullDocument?.length &&
              fullDocument?.map((obj, index) => {
                return (
                  <Row style={{ width: '100%', paddingTop: '10px' }}  key={index + "Row"}>
                    <Col span={6}>
                      <DesHeading1>
                        {obj?.docName} {obj?.mandatory ? '*' : ''}
                      </DesHeading1>
                    </Col>
                    <Col span={16} style={{ width: '100%' }}>
                      <obj.component
                        key={index+"Document"}
                        form={form}
                        formName={obj?.formName}
                      />
                    </Col>
                  </Row>
                )
              })}
          </Form>

          <Divider />
          <Row style={{ width: '100%', position: 'relative', left: '75%' }}>
            <FooterFlex end>
              <Button.Secondary text="Cancel" />

              <Button.Primary
                htmlType="submit"
                form={'documentForm'}
                text={'Submit'}
              />
            </FooterFlex>
          </Row>
        </Outline1>
      </Outline>
    
  )
}
export default OfferUploadDocument
